var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "project-single" }, [
      _c("div", { staticClass: "m-content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12" }, [
            _c(
              "div",
              {
                staticClass:
                  "m-portlet m-portlet--accent m-portlet--head-solid-bg m-portlet--head-sm",
                attrs: { "m-portlet": "true", id: "m_portlet_tools_1" }
              },
              [
                _c("div", { staticClass: "m-portlet__head" }, [
                  _c("div", { staticClass: "m-portlet__head-caption" }, [
                    _c("div", { staticClass: "m-portlet__head-title" }, [
                      _c("span", { staticClass: "m-portlet__head-icon" }, [
                        _c("i", { staticClass: "flaticon-placeholder-2" })
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "m-portlet__head-text" }, [
                        _vm._v(
                          "\n                                        Action Toolsxx\n                                    "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "m-portlet__head-tools" }, [
                    _c("ul", { staticClass: "m-portlet__nav" }, [
                      _c("li", { staticClass: "m-portlet__nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "m-portlet__nav-link m-portlet__nav-link--icon",
                            attrs: { href: "#", "m-portlet-tool": "toggle" }
                          },
                          [_c("i", { staticClass: "la la-angle-down" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "m-portlet__nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "m-portlet__nav-link m-portlet__nav-link--icon",
                            attrs: { href: "#", "m-portlet-tool": "reload" }
                          },
                          [_c("i", { staticClass: "la la-refresh" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "m-portlet__nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "m-portlet__nav-link m-portlet__nav-link--icon",
                            attrs: { href: "#", "m-portlet-tool": "fullscreen" }
                          },
                          [_c("i", { staticClass: "la la-expand" })]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "m-portlet__nav-item" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "m-portlet__nav-link m-portlet__nav-link--icon",
                            attrs: { href: "#", "m-portlet-tool": "remove" }
                          },
                          [_c("i", { staticClass: "la la-close" })]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-portlet__body" }, [
                  _c("div", {
                    staticClass: "m-scrollable",
                    staticStyle: { overflow: "hidden", height: "300px" },
                    attrs: {
                      "data-scrollbar-shown": "true",
                      "data-scrollable": "true",
                      "data-height": "300"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "m-portlet__foot" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit" }
                    },
                    [_vm._v("Submit")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "m--margin-left-10" }, [
                    _vm._v("or "),
                    _c(
                      "a",
                      {
                        staticClass: "m-link m--font-bold",
                        attrs: { href: "#" }
                      },
                      [_vm._v("Cancel")]
                    )
                  ])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }